








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import axios, { AxiosError } from 'axios';
import { format, isAfter, startOfMonth } from 'date-fns';
import { cloneDeep, isEmpty, merge } from 'lodash-es';
import Vue from 'vue';

import Utils, { loadExternalScript } from '../../Utils';
import { logout } from '../../utils/authUtils';
import LoadingHelper from '../../utils/loadingHelper';
import PlaceUtil from '../../utils/placeUtil';
import { validatorComponent } from '../../utils/validators';

import { HttpStatusCode, LocalStorageKeys } from '../../app.constants';
import FormSection from '../../components/FormSection.vue';
import Loader from '../../components/Loader.vue';
import Header from '../../components/main/Header.vue';
import Navbar from '../../components/Navbar.vue';
import SelectField from '../../components/SelectField.vue';
import TextArea from '../../components/TextArea.vue';
import TextField from '../../components/TextField.vue';
import router from '../../router';
import { store } from '../../store';

export type SectionIds =
  | 'personalInfo'
  | 'localInfo'
  | 'schoolHistory'
  | 'activities'
  | 'employmentHistory'
  | 'relatives';
export type SchoolType = 'highSchool' | 'college';
export type UFCWMemberType = 'yes' | 'no' | 'relative' | undefined;

declare const google: any;

type EditingFields = { [k in SectionIds]: boolean };

interface IPersonInfo {
  firstName: string;
  lastName: string;
  ssn: string;
}

interface IRelativeInfo extends IPersonInfo {
  id: number;
  local: string;
  employer: string;
  title: string;
  comment?: string;
}

interface IRelativeEdit extends IRelativeInfo {
  key: number;
}

interface IPersonalInfo extends IPersonInfo {
  id?: number;
  address: string;
  city: string;
  state: string;
  zipCode: number;
  birthDate: string;
  homePhone: string;
  cellPhone: string;
  email: string;
}

interface ILocalInfo {
  number: string;
  region: string;
}

interface ISchoolHistory {
  schoolName: string;
  schoolType: SchoolType;
  city: string;
  state: string;
  graduationYear: number;
  comment?: string;
}

interface ISchoolEdit extends ISchoolHistory {
  key: number;
}

enum ActivityYears {
  Freshman = 1,
  Sophomore,
  Junior,
  Senior,
}

interface IActivity {
  activityName: string;
  role: string;
  yearsParticipated: ActivityYears[];
  comment?: string;
}

interface IActivityEdit extends IActivity {
  key: number;
}

interface IEmploymentHistory {
  employerName: string;
  jobTitle: string;
  startDate: string;
  endDate: string;
  comment?: string;
}

interface IEmploymentEdit extends IEmploymentHistory {
  key: number;
}

interface IScholarshipData {
  personalInfo: IPersonalInfo | object;
  localInfo: ILocalInfo | object;
  schoolHistory: ISchoolHistory[] | object[];
  activities: IActivity[] | object[];
  employmentHistory: IEmploymentHistory[] | object[];
  relatives?: IRelativeInfo[] | object[];

  memberStatus: UFCWMemberType | '';
  essayQuestion: string;

  [key: string]: any;
}

interface IHomeData {
  relativesRequired: boolean;
  addressAutocomplete: any;
  empployerAutocomplete: any;
  editing: EditingFields;
  formData: IScholarshipData;
  hasAgreedWithTerms: boolean;
  hasLoadedData: boolean;
  loading: {
    formSubmission: boolean;
  };
  formErrors: {
    submissionError: string;
  };
  schoolEdit: ISchoolEdit;
  activityEdit: IActivityEdit;
  employmentEdit: IEmploymentEdit;
  relativeEdit: IRelativeEdit;
  persistedData: IScholarshipData;
  showLoginForm: boolean;
  loginFormData: ILoginForm;
  isAuthenticated: boolean;
  dueDate: string;
  userName: string;
}

interface IApplicant extends IPersonalInfo {
  id: number;
  userId: string;
  local: string;
  dateCreated: string;
  dateUpdated: string;
  dateDisabled: string;
  userCreated: string;
  userUpdated: string;
}

interface IEssayResponse {
  text: string;
}

interface IApplication {
  id: number;
  applicantId: number;
  year: number;
  local: string;
  essayResponses: IEssayResponse[];
  schools: ISchoolHistory[];
  activities: IActivity[];
  employers: IEmploymentHistory[];
  memberRelatives: IRelativeInfo[];
  dateCreated: string;
  dateUpdated: string;
  dateDisabled: string;
  userCreated: string;
  userUpdated: string;
}

interface IScholarshipForm {
  applicant: Partial<IApplicant>;
  application: Partial<IApplication>;
}

interface ISubmitScholarshipFormResponse {
  jwt: string;
  scholarshipForm: IScholarshipForm;
}

interface ILoginForm {
  email: string;
  password: string;
}

interface IApplicantLoginResponse {
  jwt: string;
  applicant: IApplicant;
  currentApplication: IApplication | null;
}

export default Vue.extend({
  beforeMount() {
    this.editing.personalInfo = this.personalInfoIsValid;
  },
  mounted() {
    loadExternalScript(
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    ).then(() => {
      this.setLanguage();
    });
  },
  components: {
    FormSection,
    Header,
    Loader,
    Navbar,
    SelectField,
    TextArea,
    TextField,
  },
  computed: {
    pastSchools(): ISchoolHistory[] {
      if (!this.persistedData.schoolHistory) {
        return [];
      }
      return (this.persistedData.schoolHistory as ISchoolHistory[])
        .filter(school => school.schoolName)
        .sort((a, b) => {
          const ayear = a.graduationYear;
          const byear = b.graduationYear;

          return ayear > byear ? -1 : ayear === byear ? 0 : 1;
        });
    },
    minBirthDate: () => {
      const date = startOfMonth(new Date());
      return format(date, 'MM/dd/yyyy');
    },
    maxStartDate: () => {
      const date = startOfMonth(new Date());
      return format(date, 'MM/yyyy');
    },
    pastActivities(): IActivity[] {
      if (!this.persistedData.schoolHistory) {
        return [];
      }
      return (this.persistedData.activities as IActivity[])
        .filter(activity => activity.activityName)
        .sort((a, b) => {
          if (!a.activityName) {
            return -1;
          }
          return a.activityName > b.activityName
            ? 1
            : a.activityName === b.activityName
            ? 0
            : -1;
        });
    },
    relatives(): IRelativeInfo[] {
      if (!this.persistedData.relatives) {
        return [];
      }
      return (this.persistedData.relatives as IRelativeInfo[])
        .filter(relative => relative.lastName)
        .sort((a, b) => {
          if (!a.lastName) {
            return -1;
          }
          return a.lastName + ' ' + a.firstName > b.lastName + ' ' + b.firstName
            ? 1
            : a.lastName + ' ' + a.firstName === b.lastName + ' ' + b.firstName
            ? 0
            : -1;
        });
    },
    pastEmployments(): IEmploymentHistory[] {
      if (!this.persistedData.employmentHistory) {
        return [];
      }
      return (this.persistedData.employmentHistory as IEmploymentHistory[])
        .filter(employment => employment.employerName)
        .sort((a, b) => {
          return a.startDate > b.startDate
            ? 1
            : a.startDate === b.startDate
            ? 0
            : -1;
        });
    },
    personalInfoIsValid(): boolean {
      const personalInfo = this.formData.personalInfo;

      if (!personalInfo) {
        return false;
      }
      const hasEmptyValue = Utils.hasEmptyKey(personalInfo);
      const hasAllKeys = Object.keys(personalInfo).length >= 11;

      return !!(hasAllKeys && !hasEmptyValue) as boolean;
    },
    prettyErrors(): string {
      let message;
      if ((this as any).errors.all().length > 1) {
        message =
          'There are multiple errors with the form above. Please check that all fields are correct.';
      } else {
        message =
          'There is an error with the form above. Please check your application and try again.';
      }

      return message;
    },
  },
  async created() {
    if (store.state.isAuthenticated) {
      // Disable tslint here because it doesn't like the way Axios suggests we set the auth token
      /* tslint:disable:no-string-literal */
      axios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${store.state.jwt}`;
      /* tslint:enable:no-string-literal */
    }

    const loader = new LoadingHelper(1000);
    loader.onComplete = (data: IScholarshipForm) => {
      if (data instanceof Error) {
        const err = data as any;
        if (
          err.response &&
          err.response.status === HttpStatusCode.Unauthorized
        ) {
          store.clearJwt();
        }
        Utils.toastError(
          'Could not connect to server. Please try again later.'
        );
        return;
      }

      this.loadDataToForm(data);
    };
    loader.start();

    axios
      // @ts-ignore
      .get<string>(`${process.env.VUE_APP_API_URI}/api/application/duedate`)
      .then(val => {
        if (val.data) {
          const formattedDate = format(new Date(val.data), 'MMMM dd, yyyy');
          Vue.set(this, 'dueDate', formattedDate);
        }
      })
      .catch(err => {
        Utils.toastError(
          'Could not connect to server. Please try again later.'
        );
      });

    let formData = {};

    if (store.state.isAuthenticated) {
      try {
        const res = await axios.get(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/application`
        );
        formData = res.data;
        loader.complete(formData);
      } catch (err) {
        loader.complete(err);
      }
    } else {
      loader.complete(formData);
    }
  },
  data() {
    return {
      relativesRequired: false,
      activityEdit: {},
      addressAutocomplete: null,
      editing: {
        activities: false,
        employmentHistory: false,
        localInfo: false,
        personalInfo: false,
        relatives: false,
        schoolHistory: false,
      } as EditingFields,
      employmentEdit: {},
      formData: {
        activities: [{ yearsParticipated: [] }],
      },
      formErrors: {},
      hasAgreedWithTerms: false,
      hasLoadedData: false,
      loading: {
        formSubmission: false,
      },
      persistedData: {},
      relativeEdit: {},
      schoolEdit: {},
      showLoginForm: false,
      loginFormData: {},
      isAuthenticated: store.state.isAuthenticated,
      userName: '',
      dueDate: '',
    } as IHomeData;
  },
  methods: {
    cancelEdit(section: SectionIds) {
      this.makeUneditable(section);
      const savedData = cloneDeep(this.persistedData[section]);
      // If the data is an array, we know it's one of the ones where it can have multiple entries (schools, activities, etc.)
      // In which case, we want to reset it.
      // Otherwise, we want to make it the same as the persisted data.
      if (savedData && Array.isArray(savedData)) {
        if (section === 'activities') {
          this.formData[section] = [
            {
              yearsParticipated: [],
            },
          ];
        } else {
          this.formData[section] = [{}];
        }
      } else {
        this.formData[section] = savedData as any;
      }
    },
    cancelSchoolEdit() {
      this.$validator.pause();
      Vue.set(this, 'schoolEdit', {});
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    cancelActivityEdit() {
      this.$validator.pause();
      Vue.set(this, 'activityEdit', {});
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    cancelEmploymentEdit() {
      this.$validator.pause();
      Vue.set(this, 'employmentEdit', {});
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    cancelRelativeEdit() {
      this.$validator.pause();
      Vue.set(this, 'relativeEdit', {});
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    deleteActivity() {
      this.$validator.pause();
      const key = this.activityEdit.key;
      const persistedData = this.persistedData.activities;
      persistedData.splice(key, 1);
      Vue.set(this, 'activityEdit', {});
      Vue.set(this.persistedData, 'activities', persistedData);
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    deleteEmployment() {
      this.$validator.pause();
      const key = this.employmentEdit.key;
      const persistedData = this.persistedData.employmentHistory;
      persistedData.splice(key, 1);
      Vue.set(this, 'employmentEdit', {});
      Vue.set(this.persistedData, 'employmentHistory', persistedData);
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    deleteSchool() {
      this.$validator.pause();
      const key = this.schoolEdit.key;
      const persistedData = this.persistedData.schoolHistory;
      persistedData.splice(key, 1);
      Vue.set(this, 'schoolEdit', {});
      Vue.set(this.persistedData, 'schoolHistory', persistedData);
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    deleteRelative() {
      this.$validator.pause();
      const key = this.relativeEdit.key;
      const persistedData = this.persistedData.relatives || [];
      persistedData.splice(key, 1);
      Vue.set(this, 'relativeEdit', {});
      Vue.set(this.persistedData, 'relatives', persistedData);
      this.$nextTick(function() {
        this.$validator.resume();
      });
    },
    editSchool(i: number) {
      Vue.set(this, 'schoolEdit', {
        ...this.persistedData.schoolHistory[i],
        key: i,
      });
      this.$nextTick(function() {
        const schoolAutocomplete = new google.maps.places.Autocomplete(
          (this.$refs.schoolEditInput as Vue)[0].$refs.input,
          {
            types: ['establishment'],
          }
        );
        schoolAutocomplete.setFields(['address_components', 'name']);
        schoolAutocomplete.addListener('place_changed', () => {
          this.handleSchoolEditPlaceSelection(schoolAutocomplete.getPlace());
        });
      });
    },
    editActivity(i: number) {
      Vue.set(this, 'activityEdit', {
        ...this.persistedData.activities[i],
        key: i,
      });
    },
    editEmployment(i: number) {
      Vue.set(this, 'employmentEdit', {
        ...this.persistedData.employmentHistory[i],
        key: i,
      });
      this.$nextTick(function() {
        const employerAutocomplete = new google.maps.places.Autocomplete(
          (this.$refs.employmentEditInput as Vue)[0].$refs.input,
          {
            types: ['establishment'],
          }
        );
        employerAutocomplete.setFields(['address_components', 'name']);
        employerAutocomplete.addListener('place_changed', () => {
          this.handleEmploymentEditPlaceSelection(
            employerAutocomplete.getPlace()
          );
        });
      });
    },
    editRelative(i: number) {
      if (this.persistedData.relatives) {
        Vue.set(this, 'relativeEdit', {
          ...this.persistedData.relatives[i],
          key: i,
        });
      }
    },
    handleEmploymentEditPlaceSelection(location) {
      const name = location.name;

      (this.employmentEdit as IEmploymentHistory).employerName = name;
    },
    handleEmploymentPlaceSelection(location) {
      const name = location.name;

      (this.formData
        .employmentHistory[0] as IEmploymentHistory).employerName = name;
    },
    handlePersonalPlaceSelection() {
      const location = this.addressAutocomplete.getPlace();

      const util = new PlaceUtil(location.address_components);

      const addressParts = location.address_components;

      const address = ((this.formData
        .personalInfo as IPersonalInfo).address = util.getAddress());

      (this.formData.personalInfo as IPersonalInfo).city = util.getCity();
      (this.formData.personalInfo as IPersonalInfo).state = util.getState();
      (this.formData.personalInfo as IPersonalInfo).zipCode = parseInt(
        util.getPostalCode(),
        10
      );
    },
    handleSchoolEditPlaceSelection(location) {
      const name = location.name;
      const util = new PlaceUtil(location.address_components);

      (this.schoolEdit as ISchoolHistory).schoolName = name;
      (this.schoolEdit as ISchoolHistory).city = util.getCity();
      (this.formData
        .schoolHistory[0] as ISchoolHistory).state = util.getState();
    },
    handleSchoolPlaceSelection(location) {
      const name = location.name;
      const util = new PlaceUtil(location.address_components);

      (this.formData.schoolHistory[0] as ISchoolHistory).schoolName = name;
      (this.formData.schoolHistory[0] as ISchoolHistory).city = util.getCity();
      (this.formData
        .schoolHistory[0] as ISchoolHistory).state = util.getState();
    },
    hasEmptyKey: Utils.hasEmptyKey,
    loadDataToForm(scholarshipApplication: IScholarshipForm) {
      const { applicant, application } = scholarshipApplication;

      const newPersisted = {
        personalInfo: {},
        localInfo: {},
        memberStatus: '',
        essayQuestion: '',
        schoolHistory: [{}],
        activities: [{ yearsParticipated: [] }],
        employmentHistory: [{}],
        relatives: [{}],
      } as IScholarshipData;

      const newFormData = cloneDeep(newPersisted);

      if (applicant) {
        applicant.birthDate = applicant.birthDate
          ? format(new Date(applicant.birthDate), 'MM/dd/yyyy')
          : '';
        newPersisted.personalInfo = applicant;
        (newPersisted.personalInfo as IPersonalInfo).email =
          (applicant.email && applicant.email.toLowerCase()) || '';

        if (applicant.ssn && applicant.ssn.length < 9) {
          let maskedSsn = applicant.ssn;
          while (maskedSsn.length < 9) {
            maskedSsn = '●' + maskedSsn;
          }
          (newPersisted.personalInfo as IPersonInfo).ssn = maskedSsn;
        }

        this.editing.personalInfo = false;
      } else if (store.state.isAuthenticated) {
        Vue.set(
          this,
          'userName',
          store.state.token && store.state.token['userName']
        );
      }

      if (application) {
        newPersisted.id = application.id || null;
        newPersisted.year = application.year;
        newPersisted.employmentHistory = application.employers
          ? application.employers.map(emp => {
              const newHist = emp;
              if (newHist.startDate) {
                newHist.startDate = format(
                  new Date(newHist.startDate),
                  'MM/dd/yyyy'
                );
              }
              if (newHist.endDate) {
                newHist.endDate = format(
                  new Date(newHist.endDate),
                  'MM/dd/yyyy'
                );
              }

              return newHist;
            })
          : [{}];
        newPersisted.localInfo = { number: applicant.local };
        newPersisted.schoolHistory =
          application.schools && application.schools.length > 0
            ? application.schools.map((school: ISchoolHistory) => {
                const newSchool = school;
                if (newSchool.graduationYear && school.graduationYear > 0) {
                  newSchool.graduationYear = newSchool.graduationYear;
                } else {
                  (newSchool.graduationYear as number | undefined) = undefined;
                }

                return newSchool;
              })
            : [{}];
        newPersisted.activities = (application.activities &&
          application.activities.length > 0 &&
          application.activities) || [{ yearsParticipated: [] }];
        newPersisted.employmentHistory = (application.employers &&
          application.employers.length > 0 &&
          application.employers) || [{}];

        newPersisted.relatives = ((application.memberRelatives &&
          application.memberRelatives.length > 0 &&
          application.memberRelatives.map(rel => {
            if (rel.ssn && rel.ssn.length < 9) {
              let maskedSsn = rel.ssn;
              while (maskedSsn.length < 9) {
                maskedSsn = '●' + maskedSsn;
              }
              rel.ssn = maskedSsn;
            }
            return rel;
          })) as IRelativeInfo[]) || [{}];

        newPersisted.memberStatus =
          application.memberRelatives && application.memberRelatives.length
            ? 'no'
            : 'yes';

        newPersisted.essayQuestion =
          (application.essayResponses && application.essayResponses[0].text) ||
          '';
      }

      newFormData.personalInfo = newPersisted.personalInfo;
      newFormData.memberStatus = newPersisted.memberStatus;
      newFormData.essayQuestion = newPersisted.essayQuestion;

      Vue.set(this, 'persistedData', newPersisted);
      Vue.set(this, 'formData', newFormData);

      if (!this.personalInfoIsValid) {
        this.editing.personalInfo = true;
      }

      this.hasLoadedData = true;
    },
    loadFormToPersist() {
      const newPersisted = {
        ...this.persistedData,
        essayQuestion: this.formData.essayQuestion,
        memberStatus: this.formData.memberStatus,
      } as IScholarshipData;
      (newPersisted.localInfo as ILocalInfo).number = '';
      Vue.set(this, 'persistedData', newPersisted);
    },
    logout() {
      logout();
    },
    makeUneditable(section: SectionIds) {
      this.editing[section] = false;
    },
    markSectionEditable(sectionId: SectionIds) {
      this.editing[sectionId] = true;

      this.$nextTick(function() {
        if (sectionId === 'schoolHistory') {
          const schoolAutocomplete = new google.maps.places.Autocomplete(
            (this.$refs.schoolHistoryName as Vue).$refs.input,
            {
              types: ['establishment'],
            }
          );
          schoolAutocomplete.setFields(['address_components', 'name']);
          schoolAutocomplete.addListener('place_changed', () => {
            this.handleSchoolPlaceSelection(schoolAutocomplete.getPlace());
          });
        } else if (sectionId === 'employmentHistory') {
          const employmentAutocomplete = new google.maps.places.Autocomplete(
            (this.$refs.employmentHistoryName as Vue).$refs.input,
            {
              types: ['establishment'],
            }
          );
          employmentAutocomplete.setFields(['address_components', 'name']);
          employmentAutocomplete.addListener('place_changed', () => {
            this.handleEmploymentPlaceSelection(
              employmentAutocomplete.getPlace()
            );
          });
        }
      });
    },
    async persistChanges(section: SectionIds, toastError = true) {
      const isValid = await this.$validator.validateAll(section);
      if (!isValid) {
        if (toastError) {
          const error = (this as any).errors.all(section)[0];
          Utils.toastError(error);
        }
        return false;
      }

      const fieldData = this.formData[section] as any;
      if (section === 'schoolHistory') {
        (this.persistedData[section] as ISchoolHistory[]).push({
          ...fieldData[0],
        });
        const sorted = (this.persistedData[section] as ISchoolHistory[])
          .filter(schoolHistory => schoolHistory.schoolName)
          .sort((a, b) => {
            const ayear = a.graduationYear;
            const byear = b.graduationYear;

            return ayear > byear ? -1 : ayear === byear ? 0 : 1;
          });
        Vue.set(this.persistedData, section, sorted);
        Vue.set(this.formData[section], 0, {});
      } else if (section === 'activities') {
        (this.persistedData[section] as IActivity[]).push({
          ...fieldData[0],
        });
        const sorted = (this.persistedData[section] as IActivity[])
          .filter(activity => activity.activityName)
          .sort((a, b) => {
            return a.activityName > b.activityName
              ? 1
              : a.activityName === b.activityName
              ? 0
              : -1;
          });
        Vue.set(this.persistedData, section, sorted);
        Vue.set(this.formData[section], 0, {
          yearsParticipated: [],
        });
      } else if (section === 'employmentHistory') {
        (this.persistedData[section] as IEmploymentHistory[]).push({
          ...fieldData[0],
        });
        const sorted = (this.persistedData[section] as IEmploymentHistory[])
          .filter(employment => employment.employerName)
          .sort((a, b) => {
            return a.startDate > b.startDate
              ? 1
              : a.startDate === b.startDate
              ? 0
              : -1;
          });
        Vue.set(this.persistedData, section, sorted);
        Vue.set(this.formData[section], 0, {});
      } else if (section === 'relatives') {
        const newRelative: IRelativeInfo = fieldData[0];

        (this.persistedData[section] as IRelativeInfo[]).push({
          ...newRelative,
        });
        const sorted = (this.persistedData[section] as IRelativeInfo[])
          .filter(rel => rel.lastName)
          .sort((a, b) => {
            if (!a.lastName) {
              return -1;
            }
            return a.lastName + ' ' + a.firstName >
              b.lastName + ' ' + b.firstName
              ? 1
              : a.lastName + ' ' + a.firstName ===
                b.lastName + ' ' + b.firstName
              ? 0
              : -1;
          });
        Vue.set(this.persistedData, section, sorted);
        Vue.set(this.formData[section] || [], 0, {
          yearsParticipated: [],
        });
      } else {
        this.persistedData[section] = fieldData;
      }

      this.makeUneditable(section);
    },
    async saveSchoolEdit() {
      const isValid = await this.$validator.validateAll('schoolEdit');
      if (!isValid) {
        const error = (this as any).errors.all('schoolEdit')[0];
        Utils.toastError(error);
        return;
      }

      const school = this.schoolEdit;
      const key = school.key;
      delete school.key;
      const newPersist = this.persistedData.schoolHistory;
      newPersist[key] = school;

      const sorted = (newPersist as ISchoolHistory[]).sort((a, b) => {
        const ayear = a.graduationYear;
        const byear = b.graduationYear;

        return ayear > byear ? -1 : ayear === byear ? 0 : 1;
      });
      Vue.set(this.persistedData, 'schoolHistory', sorted);
    },
    async saveActivityEdit() {
      const isValid = await this.$validator.validateAll('activityEdit');
      if (!isValid) {
        const error = (this as any).errors.all('activityEdit')[0];
        Utils.toastError(error);
        return;
      }

      const activity = this.activityEdit;
      const key = activity.key;
      delete activity.key;
      const newPersist = this.persistedData.activities;
      newPersist[key] = activity;

      const sorted = (newPersist as IActivity[])
        .filter(act => act.activityName)
        .sort((a, b) => {
          if (!a.activityName) {
            return -1;
          }
          return a.activityName > b.activityName
            ? 1
            : a.activityName === b.activityName
            ? 0
            : -1;
        });
      Vue.set(this.persistedData, 'activities', sorted);
    },
    async saveEmploymentEdit() {
      const isValid = await this.$validator.validateAll('employmentEdit');
      if (!isValid) {
        const error = (this as any).errors.all('employmentEdit')[0];
        Utils.toastError(error);
        return;
      }

      const employment = this.employmentEdit;
      const key = employment.key;
      delete employment.key;
      const newPersist = this.persistedData.employmentHistory;
      newPersist[key] = employment;

      const sorted = (newPersist as IEmploymentHistory[])
        .filter(emp => emp.employerName)
        .sort((a, b) => {
          return a.startDate > b.startDate
            ? 1
            : a.startDate === b.startDate
            ? 0
            : -1;
        });
      Vue.set(this.persistedData, 'employmentHistory', sorted);
    },
    async saveRelativeEdit() {
      const isValid = await this.$validator.validateAll('relativeEdit');
      if (!isValid) {
        const error = (this as any).errors.all('relativeEdit')[0];
        Utils.toastError(error);
        return;
      }

      const relative = this.relativeEdit;
      const key = relative.key;
      delete relative.key;
      const newPersist = this.persistedData.relatives;

      if (newPersist) {
        newPersist[key] = relative;

        const sorted = (newPersist as IRelativeInfo[])
          .filter(rel => rel.lastName)
          .sort((a, b) => {
            if (!a.lastName) {
              return -1;
            }
            return a.lastName + ' ' + a.firstName >
              b.lastName + ' ' + b.firstName
              ? 1
              : a.lastName + ' ' + a.firstName ===
                b.lastName + ' ' + b.firstName
              ? 0
              : -1;
          });

        Vue.set(this.persistedData, 'relatives', sorted);
      }
    },
    schoolTypeMap(schoolType: string) {
      const types = {
        highSchool: 'High School',
        college: 'College',
      } as any;
      return types[schoolType] || '';
    },
    finalizePending() {
      return new Promise((resolve, reject) => {
        const editing: SectionIds[] = Object.keys(this.editing).filter(
          sect => this.editing[sect]
        ) as SectionIds[];

        editing.forEach(async sect => {
          const succeeded = await this.persistChanges(sect, false);
          if (succeeded === false) {
            const hasData =
              this.formData[sect] &&
              (this.formData[sect] as object)[0] &&
              Object.values((this.formData[sect] as object)[0]).some(
                val => !!val
              );

            if (!hasData) {
              this.cancelEdit(sect);
            }
          } else {
            this.cancelEdit(sect);
          }
        });

        this.$nextTick(resolve);
      });
    },
    async submitForm() {
      await this.finalizePending();
      this.persistChanges('personalInfo');

      if (!(window as any).DEVMODE) {
        const isValid = await this.$validator.validate();

        if (!isValid) {
          return;
        }
      }

      this.formErrors.submissionError = '';
      this.loading.formSubmission = true;
      this.loadFormToPersist();
      const timer = new LoadingHelper(1000);

      timer.onComplete = <ISubmitScholarshipFormResponse>( //  tslint:disable-line
        res: ISubmitScholarshipFormResponse | AxiosError
      ) => {
        if ((res && (res as any).jwt) || (window as any).DEVMODE) {
          // @ts-ignore // typing is broken here for some reason
          const {
            jwt,
            scholarshipForm,
          }: { jwt: string; scholarshipForm: IScholarshipForm } = res;

          // Disable tslint here because it doesn't like the way Axios suggests we set the auth token
          /* tslint:disable:no-string-literal */
          axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
          /* tslint:enable:no-string-literal */

          store.setJwt(jwt);
          Vue.set(this, 'isAuthenticated', store.state.isAuthenticated);

          router.push('/submission');
        } else {
          const err = res as AxiosError;
          let errorMessage =
            'Sorry, but an unknown error has occurred. Please try again later.';
          if (
            err.response &&
            err.response.data &&
            err.response.data.error === 'EmailInUse'
          ) {
            errorMessage =
              'Sorry, an account already exists for that email address.';
          } else if (err.message === 'RelativeRequiredError') {
            errorMessage =
              'At least one relative is required for non-member applicants';
          }
          this.formErrors.submissionError = errorMessage;
          Utils.toastError(errorMessage);
        }

        this.loading.formSubmission = false;
      };

      timer.onError = err => {
        this.loading.formSubmission = false;
      };

      timer.start();

      const applicant: Partial<IApplicant> = this.persistedData.personalInfo;
      applicant.local = (this.persistedData.localInfo as ILocalInfo).number;
      const application: Partial<IApplication> = {
        activities: (this.persistedData.activities as IActivity[]) || [],
        employers:
          (this.persistedData.employmentHistory as IEmploymentHistory[]) || [],
        essayResponses: [{ text: this.persistedData.essayQuestion }],
        local: (this.persistedData.localInfo as ILocalInfo).number,
        memberRelatives:
          (this.persistedData.relatives as IRelativeInfo[]).filter(
            relative => relative.ssn
          ) || [],
        schools: (this.persistedData.schoolHistory as ISchoolHistory[]) || [],
        year: this.persistedData.year,
        id: this.persistedData.id,
        applicantId: (this.persistedData.personalInfo as IPersonalInfo).id,
      };

      if (
        this.persistedData.memberStatus === 'no' &&
        (!application.memberRelatives ||
          application.memberRelatives.length === 0)
      ) {
        timer.complete(new Error('RelativeRequiredError'));
        return;
      }

      const form: IScholarshipForm = { applicant, application };

      try {
        const submission = await axios.post<ISubmitScholarshipFormResponse>(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/application`,
          form
        );
        timer.complete(submission.data);
      } catch (err) {
        timer.complete(err);
      }
    },
    toggleAllYearsParticipated(formId: string) {
      if (formId !== 'edit') {
        const value = (this.formData.activities[0] as IActivity)
          .yearsParticipated.length
          ? []
          : [1, 2, 3, 4];
        Vue.set(this.formData.activities[0], 'yearsParticipated', value);
      } else {
        const value = this.activityEdit.yearsParticipated.length
          ? []
          : [1, 2, 3, 4];
        Vue.set(this.activityEdit, 'yearsParticipated', value);
      }
    },
    toggleLoginForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    async login() {
      const form: ILoginForm = this.loginFormData;
      try {
        const loginResponse = await axios.post<IApplicantLoginResponse>(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/auth/applicantlogin`,
          form
        );
        const { jwt, applicant, currentApplication } = loginResponse.data;

        // Disable tslint here because it doesn't like the way Axios suggests we set the auth token
        /* tslint:disable:no-string-literal */
        axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
        /* tslint:enable:no-string-literal */

        store.setJwt(jwt);
        Vue.set(this, 'isAuthenticated', store.state.isAuthenticated);

        this.loadDataToForm({
          applicant,
          application: currentApplication,
        } as IScholarshipForm);
      } catch (err) {
        let msg =
          'Sorry, but an unknown error has occurred. Please try again later.';
        if (
          err.response &&
          err.response.status === HttpStatusCode.Unauthorized
        ) {
          msg = 'Incorrect Login';
        }
        Utils.toastError(msg);
      }
    },
    setLanguage() {
      try {
        Utils.trySetLanguage();
      } catch (e) {
        localStorage.setItem(LocalStorageKeys.HAVE_SET_LANGUAGE, 'true');
      }
    },
  },
  mixins: [validatorComponent],
  name: 'Home',
  updated() {
    // prevent enter key from submitting forms
    this.$el.querySelectorAll('form').forEach(frm => {
      frm.onkeypress = e => {
        const key = e.charCode || e.keyCode || 0;
        if (key === 13) {
          e.preventDefault();
        }
      };
    });
  },
  watch: {
    'formData.essayQuestion'(newVal, oldVal) {
      const wordLength = newVal.split(' ').length;

      if (wordLength > 500) {
        this.formData.essayQuestion = oldVal;
      }
    },
    'formData.memberStatus'(newVal, oldVal) {
      if (newVal === 'no') {
        this.relativesRequired = true;
      } else {
        this.relativesRequired = false;
      }
      if (
        this.formData.memberStatus === 'no' &&
        this.persistedData.relatives &&
        (this.persistedData.relatives as any).filter(r => !!r.ssn).length === 0
      ) {
        this.editing.relatives = true;
      } else {
        this.editing.relatives = false;
      }
    },
    hasLoadedData(newVal, oldVal) {
      this.$nextTick(function() {
        if (newVal) {
          // Set up the address autocompletion
          this.addressAutocomplete = new google.maps.places.Autocomplete(
            (this.$refs.address as Vue).$refs.input
          );
          this.addressAutocomplete.setFields(['address_components']);
          this.addressAutocomplete.addListener(
            'place_changed',
            this.handlePersonalPlaceSelection
          );
        }
      });
    },
  },
});
